import { render, staticRenderFns } from "./CustomTrainerNotification.vue?vue&type=template&id=cef1c4be&scoped=true&"
import script from "./CustomTrainerNotification.vue?vue&type=script&lang=js&"
export * from "./CustomTrainerNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cef1c4be",
  null
  
)

export default component.exports